var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.362,
    height: 24.236,
    viewBox: "0 0 30.362 24.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-upload-4963725",
    transform: "translate(-106.028 -69.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24298",
    "data-name": "Path 24298",
    d: "M131.059,87.644l-2.434-.006-15.066.048-2.2-.042a4.959,4.959,0,1,1,0-9.919c.149,0,.3.006.443.019a5.824,5.824,0,0,1,6.923-3.841,7,7,0,0,1,13.209,3.9,4.96,4.96,0,0,1-.877,9.84Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24293",
    "data-name": "Path 24293",
    d: "M131.059,87.644h-.96a.34.34,0,1,1,0-.681h.96a4.278,4.278,0,0,0,.461-8.532.34.34,0,0,1-.3-.39,6.415,6.415,0,0,0,.074-.973,6.32,6.32,0,0,0-12.073-2.619.339.339,0,0,1-.41.184,5.054,5.054,0,0,0-1.479-.217,5.134,5.134,0,0,0-4.954,3.788.338.338,0,0,1-.38.248,4.188,4.188,0,0,0-.636-.047,4.279,4.279,0,0,0,0,8.557h.956a.34.34,0,1,1,0,.681h-.956a4.959,4.959,0,1,1,0-9.919c.149,0,.3.006.443.019a5.824,5.824,0,0,1,6.923-3.841,7,7,0,0,1,13.209,3.9,4.96,4.96,0,0,1-.877,9.84Z",
    transform: "translate(0)",
    fill: "#0777ed",
    stroke: "#0777ed",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24294",
    "data-name": "Path 24294",
    d: "M264.328,214.31a.26.26,0,0,1-.26-.26v-3.706a.26.26,0,0,1,.26-.26h1.637l-3.427-3.9-3.427,3.9h1.637a.26.26,0,0,1,.26.26v2.275a.26.26,0,1,1-.521,0V210.6h-1.952a.26.26,0,0,1-.2-.432l4-4.555a.269.269,0,0,1,.391,0l4,4.555a.26.26,0,0,1-.2.432h-1.952v3.446a.26.26,0,0,1-.26.26Z",
    transform: "translate(-141.329 -125.198)",
    fill: "#0777ed",
    stroke: "#0777ed",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24295",
    "data-name": "Path 24295",
    d: "M306.129,466.914a.26.26,0,0,1-.26-.26v-.6a.26.26,0,1,1,.521,0v.6A.26.26,0,0,1,306.129,466.914Z",
    transform: "translate(-186.711 -373.361)",
    fill: "#0777ed",
    stroke: "#0777ed",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24296",
    "data-name": "Path 24296",
    d: "M306.129,397.494a.26.26,0,0,1-.26-.26v-1.187a.26.26,0,1,1,.521,0v1.188A.26.26,0,0,1,306.129,397.494Z",
    transform: "translate(-186.711 -306.608)",
    fill: "#0777ed",
    stroke: "#0777ed",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24297",
    "data-name": "Path 24297",
    d: "M383.189,427.524a.26.26,0,0,1-.26-.26v-.407a.26.26,0,0,1,.521,0v.407A.26.26,0,0,1,383.189,427.524Z",
    transform: "translate(-260.189 -335.987)",
    fill: "#0777ed",
    stroke: "#0777ed",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.879361c0020b2d2bbfbf8cb62f613db7.svg";
export { ForwardRef as ReactComponent };